/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 2lCEPY1ezZ3j

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { Dialog } from "@plasmicpkgs/radix-ui";
import { DialogContent } from "@plasmicpkgs/radix-ui";
import { HiddenIfEmptyContainer } from "@myevaluations/myevals-plasmic-utils/dist/code-components/HiddenIfEmptyContainer/HiddenIfEmptyContainer"; // plasmic-import: RR3sVLmcSBJ_/codeComponent
import { DialogTitle } from "@plasmicpkgs/radix-ui";
import { StateProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/StateProvider/StateProvider"; // plasmic-import: OaGu0RHjgthJ/codeComponent
import ContactModalForm from "../../ContactModalForm"; // plasmic-import: KX-6C77UY1fL/component
import ContactModalMessageSent from "../../ContactModalMessageSent"; // plasmic-import: 4g62i_yC4jmZ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicContactModal.module.css"; // plasmic-import: 2lCEPY1ezZ3j/css

createPlasmicElementProxy;

export type PlasmicContactModal__VariantMembers = {};
export type PlasmicContactModal__VariantsArgs = {};
type VariantPropType = keyof PlasmicContactModal__VariantsArgs;
export const PlasmicContactModal__VariantProps = new Array<VariantPropType>();

export type PlasmicContactModal__ArgsType = {
  open?: string;
  onOpenChange?: (val: string) => void;
};
type ArgPropType = keyof PlasmicContactModal__ArgsType;
export const PlasmicContactModal__ArgProps = new Array<ArgPropType>(
  "open",
  "onOpenChange"
);

export type PlasmicContactModal__OverridesType = {
  root?: Flex__<"div">;
  dialogCore?: Flex__<typeof Dialog>;
  dialogContent?: Flex__<typeof DialogContent>;
  hiddenIfEmptyContainer?: Flex__<typeof HiddenIfEmptyContainer>;
  dialogTitle?: Flex__<typeof DialogTitle>;
  openProvider?: Flex__<typeof StateProvider>;
  overlayMask?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  contactModalForm?: Flex__<typeof ContactModalForm>;
  contactModalMessageSent?: Flex__<typeof ContactModalMessageSent>;
};

export interface DefaultContactModalProps {
  open?: string;
  onOpenChange?: (val: string) => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicContactModal__RenderFunc(props: {
  variants: PlasmicContactModal__VariantsArgs;
  args: PlasmicContactModal__ArgsType;
  overrides: PlasmicContactModal__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "openProvider.value",
        type: "writable",
        variableType: "text",

        valueProp: "open",
        onChangeProp: "onOpenChange"
      },
      {
        path: "dialogCore.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          (() => {
            try {
              return $state.openProvider.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "contactModalForm.isSubmitted",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <Dialog
        data-plasmic-name={"dialogCore"}
        data-plasmic-override={overrides.dialogCore}
        className={classNames("__wab_instance", sty.dialogCore)}
        defaultOpen={(() => {
          try {
            return $state.openProvider.value;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        onOpenChange={async (...eventArgs: any) => {
          generateStateOnChangeProp($state, ["dialogCore", "open"]).apply(
            null,
            eventArgs
          );
        }}
        open={generateStateValueProp($state, ["dialogCore", "open"])}
        overlayClassName={classNames({ [sty["pcls_qgYIZ0zRoEYk"]]: true })}
        themeResetClass={classNames(
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames
        )}
        triggerSlot={null}
      >
        <DialogContent
          data-plasmic-name={"dialogContent"}
          data-plasmic-override={overrides.dialogContent}
          className={classNames("__wab_instance", sty.dialogContent)}
          enterAnimations={["slide-in-from-right"]}
          enterDuration={0.3}
          exitAnimations={["slide-out-to-right"]}
          exitDuration={0.25}
          themeResetClass={classNames(
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames
          )}
        >
          <HiddenIfEmptyContainer
            data-plasmic-name={"hiddenIfEmptyContainer"}
            data-plasmic-override={overrides.hiddenIfEmptyContainer}
            className={classNames("__wab_instance", sty.hiddenIfEmptyContainer)}
          >
            <DialogTitle
              data-plasmic-name={"dialogTitle"}
              data-plasmic-override={overrides.dialogTitle}
              children={null}
              className={classNames("__wab_instance", sty.dialogTitle)}
            />
          </HiddenIfEmptyContainer>
          <StateProvider
            data-plasmic-name={"openProvider"}
            data-plasmic-override={overrides.openProvider}
            forceValue={(() => {
              try {
                return $state.dialogCore.open;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return undefined;
                }
                throw e;
              }
            })()}
            onChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "openProvider",
                "value"
              ]).apply(null, eventArgs);
            }}
            value={generateStateValueProp($state, ["openProvider", "value"])}
          />

          {(hasVariant(globalVariants, "mobile", "mobile") ? false : true) ? (
            <div
              data-plasmic-name={"overlayMask"}
              data-plasmic-override={overrides.overlayMask}
              className={classNames(projectcss.all, sty.overlayMask)}
              onClick={async event => {
                const $steps = {};

                $steps["updateDialogCoreOpen"] = true
                  ? (() => {
                      const actionArgs = {
                        variable: {
                          objRoot: $state,
                          variablePath: ["dialogCore", "open"]
                        },
                        operation: 0,
                        value: false
                      };
                      return (({
                        variable,
                        value,
                        startIndex,
                        deleteCount
                      }) => {
                        if (!variable) {
                          return;
                        }
                        const { objRoot, variablePath } = variable;

                        $stateSet(objRoot, variablePath, value);
                        return value;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateDialogCoreOpen"] != null &&
                  typeof $steps["updateDialogCoreOpen"] === "object" &&
                  typeof $steps["updateDialogCoreOpen"].then === "function"
                ) {
                  $steps["updateDialogCoreOpen"] =
                    await $steps["updateDialogCoreOpen"];
                }
              }}
              style={(() => {
                try {
                  return {
                    width: "calc(100% - 840px)"
                  };
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
            />
          ) : null}
          <div
            data-plasmic-name={"freeBox"}
            data-plasmic-override={overrides.freeBox}
            className={classNames(projectcss.all, sty.freeBox)}
          >
            {(() => {
              try {
                return !$state.contactModalForm.isSubmitted;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return true;
                }
                throw e;
              }
            })() ? (
              <ContactModalForm
                data-plasmic-name={"contactModalForm"}
                data-plasmic-override={overrides.contactModalForm}
                className={classNames("__wab_instance", sty.contactModalForm)}
                isSubmitted={generateStateValueProp($state, [
                  "contactModalForm",
                  "isSubmitted"
                ])}
                onIsSubmittedChange={async (...eventArgs: any) => {
                  generateStateOnChangeProp($state, [
                    "contactModalForm",
                    "isSubmitted"
                  ]).apply(null, eventArgs);

                  if (
                    eventArgs.length > 1 &&
                    eventArgs[1] &&
                    eventArgs[1]._plasmic_state_init_
                  ) {
                    return;
                  }
                }}
              />
            ) : null}
            {(() => {
              try {
                return $state.contactModalForm.isSubmitted;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return false;
                }
                throw e;
              }
            })() ? (
              <ContactModalMessageSent
                data-plasmic-name={"contactModalMessageSent"}
                data-plasmic-override={overrides.contactModalMessageSent}
                className={classNames(
                  "__wab_instance",
                  sty.contactModalMessageSent
                )}
                onClose={async () => {
                  const $steps = {};

                  $steps["updateContactModalFormIsSubmitted"] = true
                    ? (() => {
                        const actionArgs = {
                          variable: {
                            objRoot: $state,
                            variablePath: ["contactModalForm", "isSubmitted"]
                          },
                          operation: 0,
                          value: false
                        };
                        return (({
                          variable,
                          value,
                          startIndex,
                          deleteCount
                        }) => {
                          if (!variable) {
                            return;
                          }
                          const { objRoot, variablePath } = variable;

                          $stateSet(objRoot, variablePath, value);
                          return value;
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["updateContactModalFormIsSubmitted"] != null &&
                    typeof $steps["updateContactModalFormIsSubmitted"] ===
                      "object" &&
                    typeof $steps["updateContactModalFormIsSubmitted"].then ===
                      "function"
                  ) {
                    $steps["updateContactModalFormIsSubmitted"] =
                      await $steps["updateContactModalFormIsSubmitted"];
                  }
                }}
              />
            ) : null}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "dialogCore",
    "dialogContent",
    "hiddenIfEmptyContainer",
    "dialogTitle",
    "openProvider",
    "overlayMask",
    "freeBox",
    "contactModalForm",
    "contactModalMessageSent"
  ],
  dialogCore: [
    "dialogCore",
    "dialogContent",
    "hiddenIfEmptyContainer",
    "dialogTitle",
    "openProvider",
    "overlayMask",
    "freeBox",
    "contactModalForm",
    "contactModalMessageSent"
  ],
  dialogContent: [
    "dialogContent",
    "hiddenIfEmptyContainer",
    "dialogTitle",
    "openProvider",
    "overlayMask",
    "freeBox",
    "contactModalForm",
    "contactModalMessageSent"
  ],
  hiddenIfEmptyContainer: ["hiddenIfEmptyContainer", "dialogTitle"],
  dialogTitle: ["dialogTitle"],
  openProvider: ["openProvider"],
  overlayMask: ["overlayMask"],
  freeBox: ["freeBox", "contactModalForm", "contactModalMessageSent"],
  contactModalForm: ["contactModalForm"],
  contactModalMessageSent: ["contactModalMessageSent"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  dialogCore: typeof Dialog;
  dialogContent: typeof DialogContent;
  hiddenIfEmptyContainer: typeof HiddenIfEmptyContainer;
  dialogTitle: typeof DialogTitle;
  openProvider: typeof StateProvider;
  overlayMask: "div";
  freeBox: "div";
  contactModalForm: typeof ContactModalForm;
  contactModalMessageSent: typeof ContactModalMessageSent;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicContactModal__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicContactModal__VariantsArgs;
    args?: PlasmicContactModal__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicContactModal__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicContactModal__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicContactModal__ArgProps,
          internalVariantPropNames: PlasmicContactModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContactModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicContactModal";
  } else {
    func.displayName = `PlasmicContactModal.${nodeName}`;
  }
  return func;
}

export const PlasmicContactModal = Object.assign(
  // Top-level PlasmicContactModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dialogCore: makeNodeComponent("dialogCore"),
    dialogContent: makeNodeComponent("dialogContent"),
    hiddenIfEmptyContainer: makeNodeComponent("hiddenIfEmptyContainer"),
    dialogTitle: makeNodeComponent("dialogTitle"),
    openProvider: makeNodeComponent("openProvider"),
    overlayMask: makeNodeComponent("overlayMask"),
    freeBox: makeNodeComponent("freeBox"),
    contactModalForm: makeNodeComponent("contactModalForm"),
    contactModalMessageSent: makeNodeComponent("contactModalMessageSent"),

    // Metadata about props expected for PlasmicContactModal
    internalVariantProps: PlasmicContactModal__VariantProps,
    internalArgProps: PlasmicContactModal__ArgProps
  }
);

export default PlasmicContactModal;
/* prettier-ignore-end */
